import {
  type CommandProperties,
  createCommand,
  type SerializableValue,
} from '@canvas/rovo-content-bridge-api';

export interface PreviewPanelOpenedMessageProperties extends CommandProperties {
  ari: string;
  product?: string;
  type?: string;
  width?: number;
}

export const PreviewPanelOpenedMessage = createCommand<
  PreviewPanelOpenedMessageProperties,
  SerializableValue
>('preview-panel-opened');
